import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../../../../hooks/usePermissions';
import { useSpacePath } from '../../../../hooks/useSpacePath';
import { OpenTaskWithSubTopic } from '../../../../types';
import { useUpdateSubjectTask } from '../../api/useUpdateSubjectTask';

type Props = {
  task: OpenTaskWithSubTopic;
};

export function useOpenTaskItem(props: Props) {
  const { isAdmin } = usePermissions();
  const spacePath = useSpacePath();
  const navigate = useNavigate();
  const { mutate: updateTask } = useUpdateSubjectTask(props.task.subject_id);

  const targetUrl = props.task.sub_topics?.id
    ? spacePath(`/topics/${props.task.sub_topics.id}`)
    : undefined;

  function handleToggle(completed: boolean) {
    updateTask({
      id: props.task.id,
      state: completed ? 'completed' : 'pending',
      completed_at: completed ? new Date().toISOString() : null,
    });
  }

  function handleSubTopicClick(event?: React.MouseEvent<HTMLAnchorElement | HTMLElement>) {
    if (
      !targetUrl ||
      !event ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.altKey ||
      event.ctrlKey ||
      event.shiftKey
    ) {
      return;
    }
    event.preventDefault();
    navigate(targetUrl);
  }

  return {
    isAdmin,
    targetUrl,
    handleToggle,
    handleSubTopicClick,
  };
}
